import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {TransportInterventionsStatus} from 'shared';

@Component({
  selector: 'app-transport-interventions-realtime-list-item',
  templateUrl: './transport-interventions-realtime-list-item.component.html',
  styleUrls: ['./transport-interventions-realtime-list-item.component.scss']
})
export class TransportInterventionsRealtimeListItemComponent implements OnInit {

  @Input()
  item: TransportInterventionsStatus;

  @Output()
  menuClick = new EventEmitter<string>();

  editMenu = [
    {
      name: 'Suivre', icon: 'map', onClick: () => {
        this.menuClick.emit('follow');
      },
    },
  ];

  constructor() {
  }

  ngOnInit(): void {
  }
}
